module.exports = __webpack_public_path__ + "img/D11.be453927.svg";